import type { MainContents } from '@/types/censhare/productItemGroup';

export function findLocalizedContent(
    contents: MainContents[] | undefined,
    type: string,
    lang: string
): MainContents | undefined {
    if (!contents?.length || !type) return undefined;

    return contents.find((c) => c.type === type && c.language === lang);
}

export function filterLocalizedContent(
    contents: MainContents[] | undefined,
    type: string,
    lang: string
): MainContents[] | undefined {
    if (!contents?.length || !type) return undefined;

    const matches = contents.filter((c) => c.type === type && c.language === lang);
    if (matches.length) return matches;

    return undefined;
}
